import { useProductPageStore } from '../../contexts/ProductPageStore'
import StickyHeaderContent from './stickyHeader'

import StickyHeader from 'Clutch/Components/StickyHeader'

import Gutters from 'Clutch/Atoms/Gutters'

const StickyHeaderWrapper = ({ triggerId }) => {
  const isPowerReviewsSlidesOpen = useProductPageStore((x) => x.isPowerReviewsSlidesOpen)

  if (isPowerReviewsSlidesOpen) return null

  return (
    <StickyHeader triggerId={triggerId}>
      <Gutters noVerticalPadding>
        <StickyHeaderContent />
      </Gutters>
    </StickyHeader>
  )
}

export default StickyHeaderWrapper
